import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import type React from "react";
import { useState } from "react";
import type { ProjectRole } from "~/interface/project";
import type { User } from "~/interface/user";
import styles from "./index.module.scss";

interface MemberItem {
  user: User;
  role: ProjectRole;
  isChecked: boolean;
}

interface ModalProps {
  members: MemberItem[];
  setMembers: React.Dispatch<React.SetStateAction<MemberItem[]>>;
}

const InviteInternalUser: React.FC<ModalProps> = ({ members, setMembers }) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const filteredMembers = members.filter((member) =>
    `${member.user.display_name} ${member.user.first_name} ${member.user.last_name} ${member.user.display_name}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase()),
  );

  const handleRoleChange = (userId: string, role: ProjectRole) => {
    const updatedMembers = [...members];
    const targetMember = updatedMembers.find((member) => member.user.id === userId);
    if (targetMember) targetMember.role = role;
    setMembers(updatedMembers);
  };

  const handleIsCheckedChange = (userId: string, isChecked: boolean) => {
    const updatedMembers = [...members];
    const targetMember = updatedMembers.find((member) => member.user.id === userId);
    if (targetMember) targetMember.isChecked = isChecked;
    setMembers(updatedMembers);
  };

  return (
    <div className={styles["internalMembers"]}>
      <div className={styles["searchBar"]}>
        <input
          type="text"
          placeholder="メンバーを絞り込む"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className={styles["searchInput"]}
          data-testid="invite-search"
        />
      </div>

      <div className={styles["memberContainer"]}>
        {filteredMembers.map((member, index) => (
          <div key={index} className={styles["member"]}>
            <AccountCircleIcon style={{ fontSize: 40, color: "#1D9FD6" }} />
            <div className={styles["member__info"]}>
              <div className={styles["member__info__name"]}>
                <span>{member.user.display_name}</span>
                <p>{member.user.last_name}</p>
                <p>{member.user.first_name}</p>
              </div>
              <div className={styles["member__info__footer"]}>
                <p>{member.user.display_name}</p>
              </div>
            </div>
            <div className={styles["roleField"]}>
              <select
                value={member.role}
                onChange={(e) => handleRoleChange(member.user.id, e.target.value as ProjectRole)}
                required
              >
                {member.user.role !== "guest" ? (
                  <>
                    <option value="owner">オーナー</option>
                    <option value="contributor">編集者</option>
                    <option value="member">閲覧者</option>
                  </>
                ) : (
                  <option value="member">閲覧者</option>
                )}
              </select>
            </div>
            <div className={styles["member__checkbox"]}>
              <input
                type="checkbox"
                checked={member.isChecked}
                onChange={(e) => handleIsCheckedChange(member.user.id, e.target.checked)}
                data-testid={`invite-checkbox-${member.user.id}`}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InviteInternalUser;
